/* BKS — CONFIGURATEUR INTÉGRÉ dans les cartes « Parcours » de l'accueil (14/10/2026, demande de Ludo).
   Chantier : site/outils/1410/config-integre/ (zone accueil-integre de proprietaires.json).

   Le bouton déroulant d'une carte ouvre, sous la carte, le VRAI configurateur de la page liée (FUSION, CUSTOM),
   sans changer de page. Rien n'est chargé avant le premier survol du bouton.

   POURQUOI CE N'EST PAS UN <iframe> : Shopify sert toutes les pages de la boutique avec « frame-ancestors 'none' »
   et « X-Frame-Options: DENY » (mesuré le 14/10 sur les deux pages) : un cadre resterait vide. On monte donc le
   configurateur DANS la page :
     1. on lit la page du configurateur (même site, même thème : l'aperçu d'un brouillon reste l'aperçu) ;
     2. on en reprend les racines (FUSION : .app, #genfab, #gen ; CUSTOM : #bkssc, #bksmodal), ses feuilles et
        ses scripts, dans l'ordre de la page, SANS les blocs de lecture, la passerelle ni le bouton « retour » ;
     3. FUSION a des feuilles écrites pour une page à lui seul (html, body, *, h2, select…) : elles sont CONFINÉES au
        panneau, TOUTES (bks-fusion.css, module mousse, règle 44 px de la feuille de lecture) et avec le MÊME préfixe
        d'UNE classe (.bksaa-cfg--fusion), html/body/:root ramenés au panneau, animations renommées. Une classe et non
        un id : chaque règle prend +1 classe, les priorités ENTRE les règles du configurateur restent celles de sa page
        (mesuré le 14/10 : préfixée par un id, la remise à zéro « * { margin:0; padding:0 } » de FUSION écrasait les
        marges du module mousse et des encarts que FUSION injecte lui-même). Les <style id="bks-fusion-…"> que FUSION
        ajoute en cours de route sont confinés à la volée (observateur sur <head>) ;
        CUSTOM est déjà confiné à #bkssc par sa propre feuille : on la prend telle quelle ;
     4. deux retouches dans le script principal, comptées (au moindre écart : on n'ouvre pas, lien vers la page) :
        · « location.origin+location.pathname » → l'adresse de la page du configurateur. C'est ce qui fabrique
          le LIEN DE REPRISE (?s= FUSION, #cfg= CUSTOM) envoyé à Klaviyo (« Selle FUSION sauvegardée », flux
          UD6jvr d'Arthur, protégé) et le « _Lien config » lu par l'atelier sur la commande. Sans la retouche,
          ces liens pointeraient vers l'accueil, qui ne sait pas reprendre une selle ;
        · « window.scrollTo( » → remonte au haut du panneau (le configurateur remonte en haut de SA page à chaque
          étape : sur l'accueil, il renverrait le client tout en haut du site) ;
     5. contrôle de santé après le montage ; s'il échoue : message + lien vers la page.
   Ce fichier ne modifie AUCUN fichier du configurateur : il lit ce que sert le site au moment du clic. */
(function () {
  'use strict';
  if (window.__bksaaIntegre) return;
  window.__bksaaIntegre = 1;

  var SPECS = {
    '/pages/cree-ta-selle-50cc-fusion': {
      cle: 'fusion',
      racines: ['.app', '#genfab', '#gen'],
      perimetre: null,                                   /* toute la page (gabarit sans layout) */
      principal: /\/bks-fusion\.js(\?|$)/,
      exclure: /bks-retour|config-lecture|passerelle/,      /* scripts */
      exclureCss: /passerelle/,                            /* feuilles (celle de lecture porte « .app #pills .pill { min-height:44px } ») */
      enLigneOk: /^\s*window\.BKS_[A-Z0-9_]+\s*=/,       /* seuls les scripts en ligne de données */
      confiner: /./,                                       /* toutes ses feuilles */
      stylesInjectes: /^bks-fusion/,                       /* <style id="bks-fusion-saves-css">, <style id="bks-fusion-v2-css"> */
      nbBase: 2,
      /* retouches FACULTATIVES (appliquées si le texte est trouvé une fois exactement, sinon ignorées, sans bloquer) :
         la « bande visible » du message « Autre 50cc… » (autreBande) part du haut de l'écran ; sur l'accueil, l'en-tête
         collant de Prestige en couvre le haut — relecture du 14/10 */
      /* ⚠️ motifs en EXPRESSIONS RÉGULIÈRES tolérantes aux blancs : le CDN de Shopify sert les scripts du thème MINIFIÉS
         (« var H=window.innerHeight,haut=8,bas=H-8,sw=… », guillemets doubles) — mesuré le 14/10 à 17 h : écrits sur le
         texte source, ces deux motifs ne s'appliquaient jamais dans le navigateur. */
      facultatives: [
        [/(var H=window\.innerHeight,\s*haut=)8(\s*,)/, '$1(8+window.__bksaaIntegreHaut())$2'],
        [/(haut=sw\.getBoundingClientRect\(\)\.height\+8)(?![\d.])/, '$1+window.__bksaaIntegreHaut()']
      ],
      cfgPanier: 'FUSION',                                 /* « _bks_cfg » de ses lignes de panier */
      moduleMousse: /\/bks-mousse-addon\.js(\?|$)/,        /* module qui ajoute sa mousse à TOUT ajout de selle : voir garderMousse() */
      sante: function () {
        var p = document.getElementById('pills'), q = document.getElementById('pane');
        return !!(p && p.children.length >= 3 && q && q.children.length);
      }
    },
    '/pages/creer-ma-selle-custom': {
      cle: 'custom',
      racines: ['#bkssc', '#bksmodal'],
      perimetre: '#bkssc',                               /* la section Shopify qui le contient */
      principal: /\/bks-selle-custom-v2\.js(\?|$)/,
      exclure: /bks-retour|config-lecture|passerelle/,
      exclureCss: /passerelle|config-lecture/,
      enLigneOk: /^\s*window\.BKS_[A-Z0-9_]+\s*=/,
      confiner: null,
      stylesInjectes: null,
      nbBase: 1,
      facultatives: [],
      cfgPanier: 'CUSTOM',
      moduleMousse: null,
      sante: function () {
        var p = document.getElementById('sc-pane'), r = document.getElementById('sc-rail');
        return !!(p && p.children.length && r && r.children.length);
      }
    }
  };
  var BASE = 'location.origin+location.pathname';
  var DEFILE = 'window.scrollTo(';
  var DELAI = 15000;

  var doux = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var preps = {};          /* chemin -> promesse de préparation (page lue, feuilles et script principal lus) */
  var montes = {};         /* chemin -> 'en-cours' | 'ok' | 'ko' ('ko' seulement si un script du configurateur a déjà tourné) */
  var charges = {};        /* scripts déjà chargés (nom de fichier) */
  var ouvert = null;       /* { carte, bouton, panneau } */
  var avantMousse = null;  /* window.fetch tel qu'il était juste avant le module mousse de FUSION */

  function chemin(href) {
    try {
      var u = new URL(href, location.href);
      if (u.origin !== location.origin) return null;
      return u.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/pages\/)/i, '').replace(/\/$/, '');
    } catch (e) { return null; }
  }
  function nomFichier(url) { try { return new URL(url, location.href).pathname.split('/').pop(); } catch (e) { return url; } }
  function lireTexte(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' sur ' + url);
      return r.text();
    });
  }
  function avecDelai(p, ms) {
    return new Promise(function (ok, ko) {
      var t = setTimeout(function () { ko(new Error('délai dépassé')); }, ms);
      p.then(function (v) { clearTimeout(t); ok(v); }, function (e) { clearTimeout(t); ko(e); });
    });
  }
  function publier(nom, donnees) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(nom, donnees); } catch (e) {}
  }

  /* ---------- hauteur de l'en-tête collant (Prestige expose --sticky-area-height) ---------- */
  var sonde = null;
  function hauteurCollante() {
    if (!sonde) {
      sonde = document.createElement('div');
      sonde.setAttribute('aria-hidden', 'true');
      sonde.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;left:0;top:0;width:1px;height:var(--sticky-area-height,0px)';
      document.body.appendChild(sonde);
    }
    return sonde.offsetHeight || 0;
  }
  function defilerVers(el, comportement) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - hauteurCollante() - 10;
    window.scrollTo({ top: Math.max(0, y), behavior: doux ? (comportement || 'smooth') : 'auto' });
  }
  /* appelé par le configurateur à la place de window.scrollTo : on remonte au haut du panneau ouvert */
  window.__bksaaIntegreDefile = function (a) {
    if (!ouvert) return;                                 /* panneau refermé : surtout pas de retour en haut du site */
    var scene = ouvert.panneau.querySelector('.bksaa-integre__scene');
    var haut = scene.getBoundingClientRect().top - hauteurCollante();
    if (haut > -4 && haut < 60) return;                  /* déjà en haut du configurateur */
    defilerVers(scene, a && typeof a === 'object' && a.behavior ? a.behavior : 'smooth');
  };
  /* hauteur couverte par l'en-tête collant, pour les calculs de zone visible du configurateur (retouches facultatives) */
  window.__bksaaIntegreHaut = function () { return ouvert ? hauteurCollante() : 0; };

  /* Le module mousse de FUSION enveloppe window.fetch et ajoute sa mousse à TOUT ajout de selle (« _bks_role":"base" »).
     Sur sa page il n'y a que FUSION ; sur l'accueil, CUSTOM peut être monté aussi : une mousse choisie dans FUSION
     partait avec la selle CUSTOM, et la selle FUSION ensuite sans elle (relecture du 14/10). Cette garde, posée au-dessus,
     fait passer les ajouts d'un AUTRE configurateur (« _bks_cfg » connu et différent de FUSION) à côté du module. Un
     ajout sans « _bks_cfg » (repli brique de FUSION) passe par le module, comme sur sa page. */
  function garderMousse() {
    if (!avantMousse) return;
    var courant = window.fetch;
    if (!courant || courant.__bksaaGarde) return;
    var garde = function (u, o) {
      try {
        var url = (u && u.url) || u || '';
        if (/\/cart\/add(\.js)?/.test(url) && o && typeof o.body === 'string' && o.body.indexOf('"_bks_role":"base"') >= 0) {
          var m = /"_bks_cfg":"([^"]+)"/.exec(o.body);
          if (m && m[1] !== 'FUSION') return avantMousse.apply(this, arguments);
        }
      } catch (e) {}
      return courant.apply(this, arguments);
    };
    garde.__bksaaGarde = 1;
    window.fetch = garde;
  }

  /* ---------- confinement d'une feuille (FUSION) ---------- */
  function decouper(liste) {                            /* virgules de premier niveau seulement */
    var out = [], prof = 0, cur = '';
    for (var i = 0; i < liste.length; i++) {
      var c = liste[i];
      if (c === '(' || c === '[') prof++;
      else if (c === ')' || c === ']') prof--;
      if (c === ',' && prof === 0) { out.push(cur); cur = ''; } else cur += c;
    }
    out.push(cur);
    return out;
  }
  function prefixer(sel, portee) {
    return decouper(sel).map(function (p) {
      p = p.trim();
      var m = /^(?:html|body|:root)(?![\w-])\s*/i.exec(p);
      if (m) {
        var reste = p.slice(m[0].length);
        var m2 = /^(?:body)(?![\w-])\s*/i.exec(reste);   /* « html body … » */
        if (m2) reste = reste.slice(m2[0].length);
        if (!reste) return portee;
        return /^[.:#\[]/.test(reste) ? portee + reste : portee + ' ' + reste;
      }
      return portee + ' ' + p;
    }).join(', ');
  }
  /* La feuille est lue par le navigateur lui-même (une <style media="not all"> : analysée, jamais appliquée), puis
     réécrite règle par règle, chaque sélecteur préfixé par la classe du panneau. La remise à zéro (`all: revert`, poids
     d'une classe, voir remiseAZero) est posée une fois, AVANT la première feuille confinée. */
  var animations = {};     /* clé du configurateur -> { nom d'origine : nom confiné }, partagé par toutes ses feuilles */
  function confiner(texte, portee, prefixeAnim, noms) {
    var tmp = document.createElement('style');
    tmp.media = 'not all';
    tmp.textContent = texte.replace(/@import[^;]*;/g, '');
    document.head.appendChild(tmp);
    try { return reecrire(tmp.sheet, portee, prefixeAnim, noms || {}); }
    finally { document.head.removeChild(tmp); }
  }
  /* `.bksaa-cfg--<clé> :where(*)` = poids (0,1,0) : passe APRÈS bks-aa.css (« .bksaa :where(button) { font: inherit… } »,
     même poids) et devant les règles d'éléments de Prestige (0,0,1) : il efface ce que la page d'accueil pose sur les
     éléments nus et que la page du configurateur n'a pas ; il perd contre TOUTES les règles confinées (posées après lui,
     poids ≥ (0,1,0)). La racine du panneau, elle, reçoit les règles html/body du configurateur. */
  function remiseAZero(portee) {
    return portee + ' :where(*){all:revert}\n' + portee + '{line-height:normal;letter-spacing:normal;text-transform:none;-webkit-font-smoothing:auto;-moz-osx-font-smoothing:auto}';
  }
  function reecrire(feuille, portee, prefixeAnim, noms) {
    if (!feuille || !feuille.cssRules) throw new Error('feuille du configurateur illisible');
    (function relever(regles) {
      for (var i = 0; i < regles.length; i++) {
        var r = regles[i];
        if (window.CSSKeyframesRule && r instanceof CSSKeyframesRule) noms[r.name] = prefixeAnim + r.name;
        else if (r.cssRules) relever(r.cssRules);
      }
    })(feuille.cssRules);
    var motsAnim = Object.keys(noms);
    function renommer(decl) {
      if (!motsAnim.length) return decl;
      return decl.replace(/(animation(?:-name)?\s*:)([^;]*)/g, function (_, tete, val) {
        return tete + val.replace(/[\w-]+/g, function (mot) { return noms[mot] || mot; });
      });
    }
    var out = [];
    (function ecrire(regles) {
      for (var i = 0; i < regles.length; i++) {
        var r = regles[i];
        if (r instanceof CSSStyleRule) {
          out.push(prefixer(r.selectorText, portee) + '{' + renommer(r.style.cssText) + '}');
        } else if (window.CSSMediaRule && r instanceof CSSMediaRule) {
          out.push('@media ' + r.conditionText + '{'); ecrire(r.cssRules); out.push('}');
        } else if (window.CSSSupportsRule && r instanceof CSSSupportsRule) {
          out.push('@supports ' + r.conditionText + '{'); ecrire(r.cssRules); out.push('}');
        } else if (window.CSSKeyframesRule && r instanceof CSSKeyframesRule) {
          r.name = noms[r.name] || r.name;
          out.push(r.cssText);
        } else {
          out.push(r.cssText);                            /* @font-face et le reste : tels quels */
        }
      }
    })(feuille.cssRules);
    return out.join('\n');
  }

  /* ---------- lecture de la page du configurateur ---------- */
  function preparer(ch) {
    if (preps[ch]) return preps[ch];
    var spec = SPECS[ch];
    preps[ch] = lireTexte(ch).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var racines = spec.racines.map(function (s) {
        var n = doc.querySelector(s);
        if (!n) throw new Error('racine absente : ' + s);
        return n;
      });
      var zone = doc, enveloppe = [];
      if (spec.perimetre) {
        var r0 = doc.querySelector(spec.perimetre);
        zone = (r0 && r0.closest('.shopify-section')) || null;
        if (!zone) throw new Error('section du configurateur introuvable');
        /* l'enveloppe Prestige du configurateur sur SA page (CUSTOM : jeu de couleurs scheme-2 > conteneur > texte
           centré) : ses classes donnent les variables de couleur, la couleur des filets et l'alignement dont la feuille
           de CUSTOM hérite. On la reproduit à vide autour de lui (marges neutralisées par bks-aa-integre.css). */
        for (var a = r0.parentElement; a && a !== zone; a = a.parentElement) enveloppe.unshift({ tag: a.tagName, cls: a.className });
      }
      var styles = [], scripts = [];
      [].forEach.call(zone.querySelectorAll('link[rel="stylesheet"], script'), function (el) {
        if (racines.some(function (r) { return r.contains(el); })) return;
        if (el.tagName === 'LINK') {
          var href = el.getAttribute('href') || '';
          if (!/\/assets\/bks-/.test(href) || (spec.exclureCss || spec.exclure).test(href)) return;
          styles.push({ href: href, confiner: !!(spec.confiner && spec.confiner.test(href)) });
          return;
        }
        var type = (el.getAttribute('type') || '').toLowerCase();
        if (type && type !== 'text/javascript' && type !== 'module') return;
        var src = el.getAttribute('src');
        if (src) {
          if (!/\/assets\/bks-/.test(src) || spec.exclure.test(src)) return;
          scripts.push({ src: src, principal: spec.principal.test(src) });
        } else {
          var t = el.textContent || '';
          if (spec.enLigneOk.test(t)) scripts.push({ texte: t });
        }
      });
      if (!scripts.some(function (s) { return s.principal; })) throw new Error('script du configurateur absent de la page');
      /* le script principal et les feuilles à confiner sont lus maintenant (survol), pour que le clic soit instantané */
      return Promise.all([
        Promise.all(scripts.map(function (s) { return s.principal ? lireTexte(s.src).then(function (t) { s.texte = t; }) : null; })),
        Promise.all(styles.map(function (st) { return st.confiner ? lireTexte(st.href).then(function (t) { st.texte = t; }) : null; }))
      ]).then(function () { return { racines: racines, styles: styles, scripts: scripts, enveloppe: enveloppe }; });
    });
    preps[ch].catch(function () { delete preps[ch]; });   /* un échec réseau se retente au clic suivant */
    return preps[ch];
  }

  function retoucher(src, spec, brut) {
    var n = src.split(BASE).length - 1;
    if (n !== spec.nbBase) throw new Error('liens de reprise : ' + n + ' occurrence(s) de « ' + BASE + ' » au lieu de ' + spec.nbBase + ' — on n’ouvre pas ici');
    src = src.split(BASE).join('(location.origin+' + JSON.stringify(brut) + ')');
    src = src.split(DEFILE).join('window.__bksaaIntegreDefile(');
    (spec.facultatives || []).forEach(function (r) {
      var n = (src.match(new RegExp(r[0].source, 'g')) || []).length;
      if (n === 1) src = src.replace(r[0], r[1]);
      else try { console.info('[BKS configurateur intégré] retouche facultative non appliquée (' + n + ' occurrence(s)) : ' + r[0].source.slice(0, 60)); } catch (e) {}
    });
    return src + '\n//# sourceURL=' + spec.cle + '-integre-accueil.js';
  }
  function executer(code) {
    var erreur = null;
    function h(e) { erreur = e.error || new Error(e.message || 'erreur de script'); }
    window.addEventListener('error', h);
    var s = document.createElement('script');
    s.textContent = code;
    document.head.appendChild(s);
    window.removeEventListener('error', h);
    if (erreur) throw erreur;
  }
  function chargerScript(src) {
    var nom = nomFichier(src);
    var deja = charges[nom] || [].some.call(document.scripts, function (s) { return s.src && nomFichier(s.src) === nom; });
    if (deja) return Promise.resolve();
    charges[nom] = 1;
    return new Promise(function (ok, ko) {
      var s = document.createElement('script');
      s.src = src; s.async = false;
      s.onload = ok;
      s.onerror = function () { ko(new Error('script illisible : ' + nom)); };
      document.head.appendChild(s);
    });
  }
  /* Les feuilles du configurateur vont en FIN DE <body>, dans l'ordre de sa page : l'ordre de la cascade suit l'ordre
     du document, et elles doivent passer APRÈS bks-aa.css (en tête) et bks-aa-integre.css (dans la section). */
  function chargerFeuille(href) {
    var nom = nomFichier(href);
    if ([].some.call(document.querySelectorAll('link[data-bksaa-integre]'), function (l) { return nomFichier(l.href) === nom; })) return Promise.resolve();
    return new Promise(function (ok) {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = href;
      l.setAttribute('data-bksaa-integre', '');
      l.onload = ok; l.onerror = ok;                     /* une feuille manquante ne bloque pas */
      document.body.appendChild(l);
    });
  }

  function monter(panneau, ch, brut) {
    var spec = SPECS[ch];
    var scene = panneau.querySelector('.bksaa-integre__scene');
    return avecDelai(preparer(ch), DELAI).then(function (prep) {
      /* les retouches du script principal sont contrôlées AVANT toute écriture dans la page (feuilles, scripts) */
      var principal = prep.scripts.filter(function (s) { return s.principal; })[0];
      var codePrincipal = retoucher(principal.texte, spec, brut);
      var hote = document.createElement('div');
      hote.className = 'bksaa-cfg bksaa-cfg--' + spec.cle;
      hote.id = 'bksaa-cfg-' + spec.cle;
      var attente = [];
      var portee = '.bksaa-cfg--' + spec.cle;
      var noms = animations[spec.cle] = animations[spec.cle] || {};
      var poser = function (texte) {
        var style = document.createElement('style');
        style.setAttribute('data-bksaa-integre', spec.cle);
        style.textContent = texte;
        document.body.appendChild(style);
        return style;
      };
      var dejaPose = !!document.querySelector('style[data-bksaa-integre="' + spec.cle + '"]');   /* 2e essai après un échec réseau */
      if (!dejaPose && prep.styles.some(function (st) { return st.confiner; })) poser(remiseAZero(portee));
      prep.styles.forEach(function (st) {
        if (st.confiner) { if (!dejaPose) poser(confiner(st.texte, portee, 'bksaa-' + spec.cle + '-', noms)); }
        else attente.push(chargerFeuille(st.href));
      });
      /* les <style> que le configurateur ajoute lui-même dans <head> (FUSION : encarts « mes selles », panier v2) :
         confinés et déplacés en fin de <body> dès leur arrivée — un observateur, avant d'exécuter ses scripts */
      if (spec.stylesInjectes && !spec.observe) {
        spec.observe = true;
        var traiter = function (n) {
          if (!n || n.tagName !== 'STYLE' || !n.id || !spec.stylesInjectes.test(n.id) || n.hasAttribute('data-bksaa-integre')) return;
          try { n.textContent = confiner(n.textContent, portee, 'bksaa-' + spec.cle + '-', noms); } catch (e) { return; }
          n.setAttribute('data-bksaa-integre', spec.cle);
          document.body.appendChild(n);
        };
        [].forEach.call(document.head.querySelectorAll('style[id]'), traiter);
        new MutationObserver(function (ms) {
          ms.forEach(function (m) { [].forEach.call(m.addedNodes, traiter); });
        }).observe(document.head, { childList: true });
      }
      var dedans = hote;
      if (prep.enveloppe.length) {
        /* la typographie que la page du configurateur tient de son <body> (Prestige) : celle du <body> de l'accueil est la
           même (même thème) ; elle est reposée sur l'enveloppe, sinon le configurateur hériterait de celle de .bksaa */
        var cb = getComputedStyle(document.body);
        prep.enveloppe.forEach(function (e, i) {
          var d = document.createElement(e.tag === 'SECTION' ? 'div' : e.tag.toLowerCase());
          d.className = e.cls;
          d.setAttribute('data-bksaa-enveloppe', '');
          if (i === 0) {
            ['fontFamily', 'fontSize', 'fontWeight', 'letterSpacing', 'textTransform', 'fontStyle'].forEach(function (p) { d.style[p] = cb[p]; });
            /* interligne SANS unité (Prestige : 1.65) : getComputedStyle le rend en px (23.1px), qu'un enfant de 10 px
               hériterait tel quel ; on repose le rapport, que chaque texte recalcule à sa taille (mesuré le 14/10) */
            var lh = parseFloat(cb.lineHeight), fs = parseFloat(cb.fontSize);
            d.style.lineHeight = (lh && fs) ? String(Math.round(lh / fs * 10000) / 10000) : 'normal';
          }
          dedans.appendChild(d);
          dedans = d;
        });
      }
      prep.racines.forEach(function (n) { dedans.appendChild(document.importNode(n, true)); });
      /* les <h1> du configurateur (« BKS · FUSION », « BKS · Selle custom ») : titre de SA page, pas de l'accueil, qui n'en
         a qu'un (le logo). Ils deviennent des <div> de même classe, titre de niveau 3 pour les lecteurs d'écran ; leurs
         feuilles les visent par classe (.hdr .lg, .top .tlogo), et le script retouché est contrôlé avant d'être exécuté. */
      [].forEach.call(hote.querySelectorAll('h1'), function (h) {
        var d = document.createElement('div');
        [].forEach.call(h.attributes, function (a) { d.setAttribute(a.name, a.value); });
        d.setAttribute('role', 'heading'); d.setAttribute('aria-level', '3');
        while (h.firstChild) d.appendChild(h.firstChild);
        h.parentNode.replaceChild(d, h);
      });
      return Promise.all(attente).then(function () {
        hote.classList.add('bksaa-cfg--attente');
        scene.appendChild(hote);
        var suite = Promise.resolve();
        prep.scripts.forEach(function (s) {
          suite = suite.then(function () {
            prep.lance = true;                                               /* à partir d'ici, un échec n'est plus rejouable */
            if (spec.moduleMousse && s.src && spec.moduleMousse.test(s.src) && !avantMousse) avantMousse = window.fetch;
            if (s.principal) { executer(codePrincipal); charges[nomFichier(s.src)] = 1; return; }
            if (s.src) return chargerScript(s.src);
            executer(s.texte);
          });
        });
        return suite.then(function () {
          garderMousse();                                    /* après CHAQUE montage : la garde doit rester au-dessus du module */
          return new Promise(function (ok) { setTimeout(ok, 60); });
        }).then(function () {
          if (!spec.sante()) throw new Error('le configurateur ne s’est pas dessiné');
          return hote;
        });
      }).catch(function (e) {
        if (prep.lance) { if (!(e instanceof Error)) e = new Error(String(e)); e.lance = true; }
        throw e;
      });
    });
  }

  /* ---------- ouverture / fermeture ---------- */
  function etiquette(bouton, estOuvert) {
    var d = bouton.querySelector('.bksaa-integre__dire');
    if (d) d.textContent = estOuvert ? (d.getAttribute('data-ouvert') || d.textContent) : (d.getAttribute('data-ferme') || d.textContent);
    bouton.setAttribute('aria-expanded', estOuvert ? 'true' : 'false');
  }
  function placerEncoche(o) {
    var c = o.carte.getBoundingClientRect(), p = o.panneau.getBoundingClientRect();
    var x = Math.max(28, Math.min(p.width - 28, c.left + c.width / 2 - p.left));
    o.panneau.style.setProperty('--bksaa-integre-x', Math.round(x) + 'px');
  }
  /* « en vue » = le panneau traverse la bande du milieu de l'écran : on y cache la bulle WhatsApp (elle tomberait sur
     la barre « Suivant » du configurateur) et, hors de vue, le bouton flottant « Génère ma selle » de FUSION */
  var vue = null;
  function surveiller(o) {
    if (vue) vue.disconnect();
    if (!('IntersectionObserver' in window)) return;
    vue = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        document.documentElement.classList.toggle('bksaa-integre-en-vue', e.isIntersecting);
        var h = o.panneau.querySelector('.bksaa-cfg');
        if (h) h.classList.toggle('bksaa-cfg--hors-vue', !e.isIntersecting);
      });
    }, { rootMargin: '-30% 0px -30% 0px', threshold: 0 });
    vue.observe(o.panneau);
  }

  function fermer(o, sansDefiler) {
    if (!o) return;
    /* le focus était dans le panneau (croix, configurateur) : il revient sur le bouton déroulant, pas sur <body> */
    if (o.panneau.contains(document.activeElement)) { try { o.bouton.focus({ preventScroll: true }); } catch (e) { o.bouton.focus(); } }
    o.carte.classList.remove('is-ouvert');
    etiquette(o.bouton, false);
    o.panneau.classList.remove('is-ouvert', 'is-pose');
    document.documentElement.classList.remove('bksaa-integre-en-vue');
    if (vue) { vue.disconnect(); vue = null; }
    var fin = function () { if (!o.panneau.classList.contains('is-ouvert')) o.panneau.hidden = true; };
    if (doux && !sansDefiler) setTimeout(fin, 520); else fin();
    if (!sansDefiler) {
      var r = o.carte.getBoundingClientRect();
      if (r.top < hauteurCollante() || r.top > window.innerHeight) defilerVers(o.carte);
    }
    if (ouvert === o) ouvert = null;
  }

  function ouvrir(carte, bouton) {
    var panneau = document.getElementById(bouton.getAttribute('aria-controls'));
    var ch = chemin(bouton.getAttribute('data-bksaa-integre'));
    var brut = '';
    try { brut = new URL(bouton.getAttribute('data-bksaa-integre'), location.href).pathname; } catch (e) {}
    if (!panneau || !ch || !SPECS[ch]) { location.href = bouton.getAttribute('data-bksaa-integre'); return; }
    if (ouvert && ouvert.panneau === panneau) { fermer(ouvert); return; }
    if (ouvert) fermer(ouvert, true);
    var o = { carte: carte, bouton: bouton, panneau: panneau };
    ouvert = o;
    carte.classList.add('is-ouvert');
    etiquette(bouton, true);
    panneau.hidden = false;
    placerEncoche(o);
    void panneau.offsetHeight;                           /* départ de l'animation depuis l'état replié */
    panneau.classList.add('is-ouvert');
    setTimeout(function () { if (ouvert === o) panneau.classList.add('is-pose'); }, doux ? 560 : 0);
    setTimeout(function () { if (ouvert === o) defilerVers(panneau); }, doux ? 80 : 0);
    surveiller(o);
    publier('bks_configurateur_integre_ouvert', { configurateur: SPECS[ch].cle });

    /* déjà monté AILLEURS (section re-rendue dans l'éditeur de thème, ou 2 cartes vers le même configurateur) : ses
       scripts ont déjà tourné et ne se rejouent pas — message et lien vers la page, jamais un chargement sans fin */
    if ((montes[ch] === 'ok' || montes[ch] === 'en-cours') && !panneau.querySelector('.bksaa-cfg') && !panneau.classList.contains('is-charge')) { echec(panneau, ch, new Error('configurateur déjà monté dans un autre panneau')); return; }
    if (montes[ch] === 'ok' || montes[ch] === 'en-cours' || montes[ch] === 'ko') return;
    montes[ch] = 'en-cours';
    panneau.classList.remove('is-echec');
    var ech = panneau.querySelector('.bksaa-integre__echec'); if (ech) ech.hidden = true;
    panneau.classList.add('is-charge');
    monter(panneau, ch, brut || ch).then(function (hote) {
      montes[ch] = 'ok';
      panneau.classList.remove('is-charge');
      panneau.classList.add('is-monte');
      requestAnimationFrame(function () { hote.classList.remove('bksaa-cfg--attente'); });
      annoncer(panneau, panneau.getAttribute('data-pret'));
      if (ouvert === o) {
        surveiller(o);
        try { panneau.focus({ preventScroll: true }); } catch (e) { panneau.focus(); }   /* le lecteur d'écran entre dans le panneau */
      }
      publier('bks_configurateur_integre_pret', { configurateur: SPECS[ch].cle });
    }, function (err) {
      /* échec AVANT le premier script (réseau, délai, page changée) : rien n'a tourné, le prochain clic retente ;
         échec APRÈS : des scripts ont tourné, on ne les rejoue pas — message et lien vers la page pour la visite */
      if (err && err.lance) montes[ch] = 'ko'; else delete montes[ch];
      echec(panneau, ch, err);
    });
  }
  function echec(panneau, ch, err) {
    panneau.classList.remove('is-charge');
    panneau.classList.add('is-echec');
    var h = panneau.querySelector('.bksaa-cfg');
    if (h) h.parentNode.removeChild(h);
    var e = panneau.querySelector('.bksaa-integre__echec');
    if (e) { e.hidden = false; annoncer(panneau, (e.querySelector('p') || {}).textContent || ''); }
    try { console.warn('[BKS configurateur intégré] ' + (err && err.message ? err.message : err)); } catch (x) {}
    publier('bks_configurateur_integre_echec', { configurateur: SPECS[ch].cle, raison: String(err && err.message || err).slice(0, 120) });
  }
  function annoncer(panneau, texte) {
    var a = panneau.querySelector('.bksaa-integre__annonce');
    if (!a || !texte) return;
    a.textContent = '';
    setTimeout(function () { a.textContent = texte; }, 60);   /* vider puis remplir : le lecteur d'écran relit */
  }

  function demarrer() {
    [].forEach.call(document.querySelectorAll('[data-bksaa-integre-carte]'), function (carte) {
      var bouton = carte.querySelector('.bksaa-integre__ouvrir');
      if (!bouton || carte.hasAttribute('data-bksaa-integre-lie')) return;
      carte.setAttribute('data-bksaa-integre-lie', '');
      var ch = chemin(bouton.getAttribute('data-bksaa-integre'));
      if (!ch || !SPECS[ch]) { bouton.hidden = true; return; }   /* carte vers un parcours non pris en charge : simple lien */
      carte.classList.add('bksaa-way--integre-pret');
      /* préchargement au survol de la SOURIS et au focus clavier seulement : sur téléphone, un doigt qui passe sur le
         bouton en faisant défiler la page ne doit pas coûter ~300 Ko ; le clic charge, et l'écran d'attente le dit */
      var precharger = function () { preparer(ch).catch(function () {}); };
      bouton.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') precharger(); });
      bouton.addEventListener('focus', precharger, { once: true });
      bouton.addEventListener('click', function (e) { e.preventDefault(); ouvrir(carte, bouton); });
      var panneau = document.getElementById(bouton.getAttribute('aria-controls'));
      var fermerBtn = panneau && panneau.querySelector('.bksaa-integre__fermer');
      if (fermerBtn) fermerBtn.addEventListener('click', function () { if (ouvert && ouvert.panneau === panneau) fermer(ouvert); });
    });
  }
  window.addEventListener('resize', function () { if (ouvert) placerEncoche(ouvert); }, { passive: true });
  document.addEventListener('shopify:section:load', demarrer);   /* éditeur de thème : section re-rendue */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
